import { LayoutStandardPage } from "../layout/LayoutStandardPage"
import { PartialProjectsPage } from "../layout/Partial/PartialProjectsPage";

export const ProjectsPage = () => {

    return(
        <LayoutStandardPage component={PartialProjectsPage.toString()} />
    )
}